import React from "react";

export const TearmsAndCondition = () => {
  return (
    <>
      <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="col-12 col-lg-9 p-0">
            <main
              className="terms-container"
              data-purpose="terms-summary-container"
            >
              {/* Header */}
              <header className="mb-4">
                <h1 className="fw-bold fs-3 mb-4">Summary of these Terms</h1>
                <p className="terms-body mb-3">
                  Along with the Terms on this page, two other documents form
                  part of our contract with you:
                </p>
              </header>
              {/* Additional Documents List */}
              <ul
                className="terms-body mb-4 ps-4"
                style={{ listStyle: "disc" }}
                data-purpose="additional-documents-list"
              >
                <li className="mb-3">
                  Our{" "}
                  <a className="link-text" href="#">
                    How We Work page
                  </a>{" "}
                  helps you use our Platform and understand our reviews,
                  rankings, recommendations, how we make money, and more.
                </li>
                <li className="mb-3">
                  Our
                  <a className="link-text" href="#">
                    Content Standards and Guidelines
                  </a>
                  help us keep everything on our Platform relevant to and
                  appropriate for our global audience without limiting freedom
                  of expression. They tell you how we manage content and online
                  safety and take action against anything inappropriate.
                </li>
              </ul>
              {/* Legal Notice Sections */}
              <section
                className="terms-body"
                data-purpose="legal-notice-sections"
              >
                <p className="mb-3">
                  By agreeing to our Terms, you agree to everything in all three
                  documents. If you don't accept any of these Terms, please
                  don't use our Platform.
                </p>
                <p className="mb-3">
                  All this information is important because it (along with your
                  booking confirmation email and any pre-contractual information
                  provided before you book) sets out the legal terms on which
                  Service Providers offer their Travel Experiences through our
                  Platform.
                </p>
                <p className="mb-3">
                  If something goes wrong with your Travel Experience,
                  <a className="link-text" href="#">
                    Section A16 of these Terms
                  </a>
                  explains what you can do about it. This includes making a
                  complaint to us, going to court, and (in some cases) using an
                  online dispute resolution service.
                </p>
                <p className="mb-3">
                  If you want to appeal to a moderation decision or report any
                  content on our Platform, our
                  <a className="link-text" href="#">
                    Content Standards and Guidelines
                  </a>
                  explain how to do so and how we manage these requests.
                </p>
              </section>
              {/* Navigation Actions */}
              <div
                className="mt-5 d-flex flex-column flex-sm-row gap-3 border-top pt-4"
                data-purpose="navigation-actions"
              >
                <button
                  className="btn btn-accept order-2 order-sm-1"
                  id="accept-button"
                  type="button"
                >
                  I Accept
                </button>
                <button
                  className="btn btn-back order-1 order-sm-2"
                  id="back-button"
                  type="button"
                >
                  Back
                </button>
              </div>
            </main>
          </div>
        </div>
      </div>

      <style>{`
 body {
        font-family: "Inter", sans-serif;
        color: #1a1a1a;
        line-height: 1.5;
        background-color: #ffffff;
        padding: 1.5rem;
      }

      @media (min-width: 768px) {
        body {
          padding: 3rem;
        }
      }

      h1 {
        letter-spacing: -0.02em;
      }

      .link-text {
        color: #006ce4;
        text-decoration: none;
      }

      .link-text:hover {
        text-decoration: underline;
      }

      .terms-container {
        max-width: 896px; /* equivalent to max-w-4xl */
      }

      .terms-body {
        font-size: 15px;
      }

      .btn-accept {
        background-color: #006ce4;
        border-color: #006ce4;
        font-weight: 600;
        padding: 0.75rem 2rem;
        color: #fff;
      }

      .btn-accept:hover {
        background-color: #0059c1;
        border-color: #0059c1;
        color: #fff;
      }

      .btn-back {
        color: #006ce4;
        border-color: #006ce4;
        font-weight: 600;
        padding: 0.75rem 2rem;
        background-color: transparent;
      }

      .btn-back:hover {
        background-color: #006ce4;
        color: #fff;
      }
      `}</style>
    </>
  );
};
